module.exports = __webpack_public_path__ + "media/signup-react/blue-oval-994173fa.png";